import React from "react";
import TextInput from "../../Components/Inputs/TextInput";

export default function ({register, errors, control, data, watch}) {

  return (
    <>
      <TextInput
        label="First Name"
        name="first_name"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.first_name}
      />
      <TextInput
        label="Last Name"
        name="last_name"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.last_name}
      />
      <TextInput
        label="Personal Number"
        name="personal_number"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.personal_number}
      />
      <TextInput
        label="Phone"
        name="phone"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.phone}
      />
      <TextInput
        label="Address"
        name="address"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.address}
      />
      <TextInput
        label="Address Type"
        name="address_type"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.address_type}
      />
    </>
  );
}